import { TableCell, TableRow, Avatar, Box, IconButton } from '@mui/material';
import { Link } from 'react-router';
import { CalendarBlank, ArrowRight } from '@phosphor-icons/react';
import { Api } from '../../api';
import { serverImageUrl } from '../../util';
import { Model } from '../../models';

type Props = {
  clinician: Api.User.V_ClinicianListAsAdmin;
};

export default function ClinicianRow({ clinician }: Props) {
  return (
    <TableRow
      component={Link}
      to={`/clinicians/${clinician.id}`}
      sx={{
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <TableCell>
        <Box display="flex" alignItems="center" gap={2}>
          <Avatar
            alt={clinician.name ?? ''}
            src={
              clinician.displayPicture
                ? serverImageUrl({ id: clinician.displayPicture.id })
                : undefined
            }
          />
          {clinician.name}
        </Box>
      </TableCell>
      <TableCell>{clinician.email}</TableCell>
      <TableCell>{Model.User.getClinicianRoleLabel(clinician)}</TableCell>
      <TableCell align="center">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={1}
          component={Link}
          to={`/clinicians/${clinician.id}/assigned-users`}
          sx={{
            textDecoration: 'none',
            color: 'inherit',
            '&:hover': {
              color: 'primary.main',
            },
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {clinician.totalClients}
          <IconButton size="small" sx={{ color: 'primary.main' }}>
            <ArrowRight size={16} />
          </IconButton>
        </Box>
      </TableCell>
      <TableCell align="center">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={1}
          component={Link}
          to={`/clinicians/${clinician.id}/appointments`}
          sx={{
            textDecoration: 'none',
            color: 'inherit',
            '&:hover': {
              color: 'primary.main',
            },
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <IconButton size="small" sx={{ color: 'primary.main' }}>
            <CalendarBlank size={16} />
          </IconButton>
        </Box>
      </TableCell>
    </TableRow>
  );
}
